import React, {Component} from 'react';
import publicpb from '../../../base/public.pb';
import disabledpb from './disabled.pb';
import PbAjax from '../../../lib/pbajax';
import lang from '../../../lang/index';

const pbajax = new PbAjax();

class StopLive extends Component {
    static defaultProps = {
        roomId: '',
        hostInfo: {}
    }
    constructor(props) {
        super(props);

        this.state = {
            hostRoomInfo: {}
        }
    }

    componentWillMount(){
        let promise = this.getDisabledIntoMsg();

        promise.done((data)=>{
            this.setState({
                hostRoomInfo: data
            });
        })
    }

    getDisabledIntoMsg() {
        let self = this;
        let { Request, Response} = disabledpb.Room.AnchorDisabledGet;

        let businessData = new Request({
            roomId: this.props.roomId,
        });
        let defer = $.Deferred();
    
        pbajax.do({
                service: 'room', 
                api: '/room/anchor/disabled/get',
                header: {
                    userToken: UP.Global.getUserToken(),
                    'Accept-Language':  UP.Global.siteLanguage
                }
            },
            businessData,
            function(res) {

                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                if (dataWrap.code == 1) {
                    data = Response.decode(dataWrap.data.value);
                    defer.resolve(data);

                } else {
                    defer.reject();
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            }
        );

        return defer.promise();
    }

    backhome() {
        hashHistory.push('/home');
    }

    render() {
        let hostInfo = this.props.hostInfo;
        let { hostRoomInfo } = this.state;
        let diamond = longToString(hostRoomInfo.moneyTotal) || 0;
        let likeNum = longToString(hostRoomInfo.likeNum) || 0;
        let viewer = longToString(hostRoomInfo.peoples) || 0;

        return (
            <div className="excetion-wrap livend">
                <div className="content">
                    <div className="content-hd">
                        <div className="avatar">
                            <img src={hostInfo.avatar}/>
                        </div>
                        <span className="nickname">{hostInfo.username}</span>
                    </div>
                    <div className="content-bd">
                        <div className="time"></div>
                        <div className="viewer">
                            <em>{ viewer }</em>
                            { lang.template('观看人数')}
                        </div>
                        {
                            // <ul>
                            //     <li className="diamond">
                            //         <em>{ diamond}</em>
                            //         {lang.template('U币')}
                            //     </li>
                            //     <li className="likenum">
                            //         <em>{ likeNum  }</em>
                            //         {lang.template('点亮数量')}
                            //     </li>
                            // </ul>
                        }
                    </div>
                </div>
                {
                    this.props.from !== 'home' ?  (
                        <div className="btns">
                            <button className="home" onClick={this.backhome}>{lang.template('去看看其他主播')}</button>
                        </div>
                    ) : null
                }
            </div>
        );
    }
}

export default StopLive;


// WEBPACK FOOTER //
// ./js/living/view/exception/livend.js